import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./OdberneMiesta.scss";

// prop types
import odberneMiestaPropTypes from "../../propTypes/odberneMiestaPropTypes";

// components
import Grid from "../../zisComponents/grid/Grid";
import ErrorMsg from "../ErrorMsg";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as odberneMiestaActions from "../../actions/odberneMiesta/odberneMiestaActions";

class OdberneMiesta extends React.Component {
  constructor(props) {
    super(props);

    this.gridFilter = { filters: [] };
    this.gridSort = [];
    this.gridPage = { skip: 0, take: 10 };
  }


  // GRID PROPS
  genGridSchema = () => {
    return [
      { field: "NAZOV", title: "Názov", width: "auto" },
      { field: "C_OM", title: "Číslo OM", width: "auto" }
    ]
  };
  genGridDetailSchema = () => {
    return [
      { field: "ADRESA_ODBERU", title: "Adresa odberu" },
    ];
  };
  onChangeHandle = (filter, sort, page) => {
    this.gridFilter = filter;
    this.gridSort = sort;
    this.gridPage = page;
  };
  onRowDoubleClickHandle = async (event) => {
    const data = this.buildChangeOMData(event.dataItem);
    await this.props.changeOM(data, true);
  };
  getListOMHandle = async () => {
    const { customFilters, getListOM } = this.props;
    const { gridFilter, gridSort, gridPage } = this;

    await getListOM(gridFilter, gridSort, gridPage, customFilters);
  };

  // METHODS
  buildGridsProps = () => {
    return {};
  };
  buildChangeOMData = (OM) => {
    const grids = this.buildGridsProps();

    return {
      OM,
      grids,
    };
  };

  // SYSTEM METHODS;
  componentDidMount() {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(true);
    changeHeaderTitle("Odberné miesta");
  }

  render() {
    const {
      isZmluvaPicked,
      isOMPickedByDoubleClickInGridRow,
      isLoading,
      odberneMiesto,
      listOM,
      total,
    } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <Grid
            className={isZmluvaPicked ? "" : "hidden"}
            data={
              isOMPickedByDoubleClickInGridRow ? [odberneMiesto] : listOM
            }
            isLoading={isLoading}
            onChange={this.onChangeHandle}
            onGet={() => { }}
            onGetList={this.getListOMHandle}
            onRowDoubleClick={this.onRowDoubleClickHandle}
            primaryField="I_ZIS_OM"
            schema={this.genGridSchema()}
            detailSchema={this.genGridDetailSchema()}
            total={isOMPickedByDoubleClickInGridRow ? 1 : total}
          />
          {!isZmluvaPicked && <ErrorMsg text="Vyberte zmluvu" />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // list OM
    customFilters: state.listOM.customFilters,
    listOMFilter: state.listOM.filter,
    isLoading: state.listOM.isLoading,
    listOM: state.listOM.data,
    total: state.listOM.total,

    // OM
    isOMPickedByDoubleClickInGridRow: state.OM.isPickedByDoubleClickInGridRow,
    odberneMiesto: state.OM.data,

    // zmluva
    isZmluvaPicked: state.zmluva.isPicked,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getListOM: async (gridFilter, gridSort, gridPage, customFilters) =>
    await dispatch(
      odberneMiestaActions.getListOM({
        gridFilter,
        gridSort,
        gridPage,
        customFilters,
      })
    ),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  changeOM: async (OM, gridRowDoubleClicked = false) =>
    await dispatch(odberneMiestaActions.changeOM(OM, gridRowDoubleClicked)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

OdberneMiesta.propTypes = {
  customFilters: PropTypes.arrayOf(PropTypes.object),
  changeHeaderTitle: PropTypes.func,
  changeOM: PropTypes.func,
  getListOM: PropTypes.func,
  isLoading: PropTypes.bool,
  isOMPickedByDoubleClickInGridRow: PropTypes.bool,
  isZmluvaPicked: PropTypes.bool,
  listOM: PropTypes.arrayOf(odberneMiestaPropTypes.odberneMiesto),
  odberneMiesto: odberneMiestaPropTypes.odberneMiesto,
  showAppHeader: PropTypes.func,
  total: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(OdberneMiesta);
